import React from "react";
import moment from "moment";
import NoRecordIcon from "../../../components/Icons/NoRecordIcon";
import PaginationComponent from "../../../components/comman/PaginationComponent";

const AttendanceTable = ({
  attendanceList = [],
  dateFilter,
  userDetails,
  handleChangeAttendance,
  ActionData,
  currentPage = 1,
  totalPages = 0,
  handlePageChange,
  pageSize = 10,
  handlePageSizeChange,
}) => {
  const generateMonthDays = () => {
    const start = moment(dateFilter[0]);
    const days = [];
    const totalDays = start.daysInMonth();
    for (let i = 1; i <= totalDays; i++) {
      days.push(i);
    }
    return days;
  };

  return (
    <>
      <div className="d-flex justify-content-between mb-2">
        {[
          { label: " -- Pending", color: "warning" },
          { label: " P - Present", color: "success" },
          { label: " A - Absent", color: "danger" },
          { label: " L - Leave", color: "info" },
          { label: " PL - Pending Leave", color: "warning" },
          { label: " PA - Pending AR", color: "warning" },
          { label: " PO - Pending OD", color: "warning" },
          { label: " WO - Weekly Off", color: "warning" },
          { label: "WFH - Work From Home", color: "success" },
          { label: "PW - Pending WFH", color: "warning" },
        ].map((item, i) => (
          <div key={i} className="d-flex align-items-center px-3 gap-2">
            <div
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                background: `var(--bs-${item.color})`,
              }}
            />
            <span className="fw-medium fs-6">{item.label}</span>
          </div>
        ))}
      </div>

      <div
        className="table-responsive"
        style={{ position: "relative", zIndex: 0 }}
      >
        <table
          className="table table-bordered table-sm align-middle text-center"
          style={{ position: "relative", zIndex: 0 }}
        >
          <thead
            className="table-light text-center align-middle"
            style={{ position: "sticky", top: 0, zIndex: 4 }}
          >
            {attendanceList?.length > 0 && (
              <tr>
                <th
                  style={{
                    position: "sticky",
                    left: 0,
                    width: "70px",
                    minWidth: "70px",
                    maxWidth: "70px",
                    zIndex: 3,
                    backgroundColor: "#f8f9fa",
                    whiteSpace: "nowrap",
                  }}
                >
                  Sr. No.
                </th>
                <th
                  style={{
                    position: "sticky",
                    left: "70px",
                    width: "160px",
                    minWidth: "160px",
                    maxWidth: "160px",
                    zIndex: 3,
                    backgroundColor: "#f8f9fa",
                    whiteSpace: "nowrap",
                  }}
                >
                  Emp. Code
                </th>
                <th
                  style={{
                    position: "sticky",
                    left: "230px",
                    width: "220px",
                    minWidth: "220px",
                    maxWidth: "220px",
                    zIndex: 3,
                    backgroundColor: "#f8f9fa",
                    whiteSpace: "nowrap",
                    borderRight: "2px solid #dee2e6",
                  }}
                >
                  Employee Name
                </th>
                {generateMonthDays()?.map((day) => (
                  <th key={day} className="p-2">
                    <span className="badge bg-light border border-1 text-black rounded-pill fs-5 fw-semibold px-3 py-2">
                      {String(day).padStart(2, "0")}
                    </span>
                  </th>
                ))}
                {ActionData?.length > 0 && <th>Action</th>}
              </tr>
            )}
          </thead>

          <tbody>
            {attendanceList?.length > 0 ? (
              attendanceList.map((user, index) => {
                const globalIndex = (currentPage - 1) * pageSize + index + 1;
                return (
                  <tr key={user.id}>
                    <td
                      style={{
                        position: "sticky",
                        left: 0,
                        width: "70px",
                        minWidth: "70px",
                        maxWidth: "70px",
                        zIndex: 1,
                        backgroundColor: "#fff",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {globalIndex}
                    </td>
                    <td
                      style={{
                        position: "sticky",
                        left: "70px",
                        width: "160px",
                        minWidth: "160px",
                        maxWidth: "160px",
                        zIndex: 1,
                        backgroundColor: "#fff",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {user.employeeCode}
                    </td>
                    <td
                      className="text-start d-flex align-items-center gap-2"
                      style={{
                        position: "sticky",
                        left: "230px",
                        width: "220px",
                        minWidth: "220px",
                        maxWidth: "220px",
                        zIndex: 1,
                        backgroundColor: "#fff",
                        whiteSpace: "nowrap",
                        borderRight: "2px solid #dee2e6",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                      }}
                    >
                      {user?.profilePhoto && (
                        <img
                          src={user.profilePhoto}
                          alt=""
                          width={32}
                          height={32}
                          className="rounded-circle"
                        />
                      )}
                      <span
                        style={{
                          maxHeight: "32px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                        }}
                      >
                        {user.name}
                      </span>
                    </td>

                    {generateMonthDays()?.map((day) => {
                      const att = user?.attendances?.find((a) => {
                        const checkInDate = new Date(
                          a.checkInTime,
                        ).getUTCDate();
                        return checkInDate === day;
                      });

                      const statusValue = att?.status ?? "pending";

                      const getClassName = () => {
                        switch (statusValue) {
                          case 1:
                            return "text-success";
                          case 0:
                            return "text-danger";
                          case 3:
                            return "text-info";
                          case 8:
                            return "text-success";
                          default:
                            return "text-warning";
                        }
                      };

                      const currentMonthDate = moment(dateFilter[0]).date(day);
                      // const isFutureDate = currentMonthDate.isAfter(
                      //   moment(),
                      //   "day"
                      // );

                      const isDisabled =
                        att?.isLockedAttendance ||
                        [4, 5, 6, 7].includes(statusValue) ||
                        (userDetails?.department?.name !== "HRM" &&
                          !(
                            userDetails?.department?.name === "Solar / Wind" &&
                            userDetails?.designation?.name === "Plant Head"
                          )) ||
                        userDetails?.isAttendanceMarkLoading;

                      return (
                        <td key={day}>
                          <select
                            className={`form-select fw-normal p-2 rounded-4 ${getClassName()}`}
                            style={{
                              borderColor:
                                statusValue === 1
                                  ? "#28a745" // green
                                  : statusValue === 0
                                    ? "#dc3545" // red
                                    : statusValue === 3
                                      ? "#0dcaf0" // blue
                                      : statusValue === 8
                                        ? "#28a745" // green
                                        : "#ffc107", // yellow (pending)
                              color:
                                statusValue === 1
                                  ? "#28a745"
                                  : statusValue === 0
                                    ? "#dc3545"
                                    : statusValue === 3
                                      ? "#0dcaf0" // blue
                                      : statusValue === 8
                                        ? "#28a745" // green
                                        : "#ffc107", // yellow (pending)
                              fontWeight: 500,
                              width: "60px",
                            }}
                            value={statusValue}
                            onChange={(e) =>
                              handleChangeAttendance(
                                Number(e.target.value),
                                user?.id,
                                user?.name,
                                moment(dateFilter[0])
                                  .date(day)
                                  .format("YYYY-MM-DD"),
                              )
                            }
                            disabled={isDisabled}
                          >
                            {statusValue === "pending" && (
                              <option
                                className="d-none"
                                value="pending"
                                disabled
                              >
                                --
                              </option>
                            )}
                            <option style={{ color: "green" }} value={1}>
                              P
                            </option>
                            <option style={{ color: "red" }} value={0}>
                              A
                            </option>
                            <option style={{ color: "cyan" }} value={3}>
                              L
                            </option>
                            {statusValue === 4 && <option value={4}>PL</option>}
                            {statusValue === 5 && <option value={5}>PA</option>}
                            {statusValue === 6 && <option value={6}>PO</option>}
                            {statusValue === 7 && <option value={7}>WO</option>}
                            {statusValue === 8 && <option style={{ color: "green" }} value={8}>WFH</option>}
                            {statusValue === 9 && <option value={9}>PW</option>}
                          </select>
                        </td>
                      );
                    })}
                    {ActionData?.length > 0 && (
                      <td>
                        <div className="action-btns d-flex gap-1 justify-content-center">
                          {ActionData.map((action, index) => (
                            <button
                              key={index}
                              className={action.className}
                              title={action.title}
                              disabled={action?.disabled}
                              onClick={() => action.clickHandler(user)}
                            >
                              {action?.icon}
                              {!action?.icon && action.label}
                            </button>
                          ))}
                        </div>
                      </td>
                    )}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td className="text-center border-0 py-5" colSpan="35">
                  <div className="d-flex flex-column justify-colmn-center align-items-center no-data-error">
                    <NoRecordIcon />
                    {"No record found"}
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {totalPages > 0 && (
        <div className="d-flex justify-content-between align-items-center mt-3 mb-2">
          {handlePageSizeChange && (
            <div className="d-flex align-items-center gap-2">
              <span className="text-secondary fs-5 fw-medium">
                Items per page:
              </span>
              <select
                className="form-select form-select-sm shadow-none cursor-pointer"
                style={{ width: "80px", borderColor: "#ced4da" }}
                value={pageSize}
                onChange={handlePageSizeChange}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </div>
          )}
          <PaginationComponent
            currentPage={currentPage}
            PageChangeHandler={handlePageChange}
            totalPages={totalPages}
            pageSize={pageSize}
          />
        </div>
      )}
    </>
  );
};

export default AttendanceTable;
